import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './client';

export function creaQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (intents, error) =>
          !(error instanceof ApiError && [401, 403, 404].includes(error.status)) && intents < 2,
        refetchOnWindowFocus: false,
      },
    },
  });
}
